import "regenerator-runtime/runtime";
import "core-js/stable";
import elementClosestPolyfill from "element-closest";
import "core-js/es/array/flat-map";

elementClosestPolyfill(window);